// Real distribution checked live on the dev archive, 2026-09-22 (app.Questions.responseCount,
// type='scale'): 5 (Likert, most common), 4, 2, and 10 (the NPS 0-10 scale, by far the rarest at
// ~1% of rows) — 10 gets a color that pops since that's the one Ben actually needs to spot at a
// glance before associating into the eNPS row. 5 (the default/neutral case) uses the same teal
// as the "Comptes" screen's own accent (ctaColor, #1b759a) instead of Chip's plain grey default —
// Chip's own grey read as too dark next to the others (Tom, 2026-09-22). Shared across the scan
// suggestions, the catalog suggestions, and the "Banque de questions" list itself.
export const SCALE_POINTS_COLORS: Record<number, string | undefined> = {
  2: "#7048E8",
  4: "#0CA678",
  5: "#1b759a",
  10: "#F08C00"
}
